import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import moment from "moment";
import {
  actionFindAll,
  actionPaymentStatus,
  actionResetList,
  actionTaskTypes
} from "actions/action/actions";

const BikeSingleHistory = (props) => {
  const {
    actionResetList,
    actionTaskTypes,
    actionPaymentStatus,
    actionFindAll,
    bikeId,
    actionList,
    taskTypes,
    // paymentStatus
  } = props;
  useEffect(() => {
    actionTaskTypes();
    actionPaymentStatus();
    actionFindAll(0, 10, "end,desc", [{
      fieldName: "bike",
      fieldValue: bikeId,
      searchOperation: "EQUALS"
    }]);

    return () => {
      actionResetList();
    };
  }, [actionTaskTypes, actionPaymentStatus, actionFindAll, actionResetList, bikeId]);

  if (!Object.keys(actionList).length || !actionList.content) return null;

  return (
    <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
      <thead>
      <tr>
        <th>ID</th>
        <th>User</th>
        <th>Task</th>
        <th>Start</th>
        <th>End</th>
        <th>Distance</th>
        <th>Payment Amount</th>
        <th>Payment Status</th>
        <th>Bonus</th>
      </tr>
      </thead>
      <tbody>
      {actionList.content.map(value => (
        <tr key={value.id}>
          <td>
            {value.id}
          </td>
          <td>
            <Link to={`/users/${value.user}`}>
              {value.user}
            </Link>
          </td>
          <td>
            {taskTypes[value.task] || ""}
          </td>
          <td>
            {moment(value.start)
              .format("HH:mm YYYY-MM-DD")}
          </td>
          <td>
            {moment(value.end)
              .format("HH:mm YYYY-MM-DD")}
          </td>
          <td>
            {value.distance}
          </td>
          <td>
            {value.payment && typeof value.payment.amount !== "undefined"
              ? value.payment.amount
              : ""}
          </td>
          <td>
            {value.payment && value.payment.status
              ? value.payment.status
              : ""}
          </td>
          <td>{value.bonus ? "Yes" : "No"}</td>
        </tr>
      ))}
      </tbody>
    </table>
  );
};

BikeSingleHistory.propTypes = {
  bikeId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  taskTypes: state.action.taskTypes,
  paymentStatus: state.action.paymentStatus,
  actionList: state.action.actionList,
});

const mapStateToDispatch = dispatch => ({
  actionTaskTypes: bindActionCreators(actionTaskTypes, dispatch),
  actionFindAll: bindActionCreators(actionFindAll, dispatch),
  actionResetList: bindActionCreators(actionResetList, dispatch),
  actionPaymentStatus: bindActionCreators(actionPaymentStatus, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(BikeSingleHistory);



// WEBPACK FOOTER //
// ./src/views/pages/bikes/bike-single-history.js